import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreLegacyModule } from '@isophi/core-legacy';
import { TeachersSharedModule } from '@isophi/teachers-shared';
import { TranslocoModule } from '@jsverse/transloco';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSkeletonModule } from 'ngx-skeleton';

import { InfoBannerComponent } from './components/header/info-banner/info-banner.component';
import { InnitialPopupComponent } from './components/innitial-popup/innitial-popup.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PreparedLinkComponent } from './components/prepared-link/prepared-link.component';
import { PrepareLinksPipe } from './pipes/prepare-links.pipe';

@NgModule({
  imports: [CommonModule, CoreLegacyModule, TeachersSharedModule, NgbModule, FormsModule, RouterModule, NgSelectModule, TranslocoModule],
  declarations: [NotFoundComponent, PrepareLinksPipe, InfoBannerComponent, InnitialPopupComponent, PreparedLinkComponent],
  exports: [
    TeachersSharedModule,
    RouterModule,
    NgbModule,
    NgxSkeletonModule,
    TranslocoModule,
    PrepareLinksPipe,
    InfoBannerComponent,
    PreparedLinkComponent,
  ],
})
export class SharedModule {
  public static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [],
    };
  }
}
